import { render, staticRenderFns } from "./UserInformationSection.vue?vue&type=template&id=b8e93140&"
import script from "./UserInformationSection.vue?vue&type=script&lang=js&"
export * from "./UserInformationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports